import { MigrateFunctionBuilder } from '@salsita-ai/platform-project-sdk/domain';
import { modelVersion, modelVersions } from '../__generated/model/index.js';
import { migrateToV2 } from './v2.js';
import { migrateToV3 } from './v3.js';
import { migrateToV4 } from './v4.js';
import { migrateToV5 } from './v5.js';
import { migrateToV6 } from './v6.js';
import { migrateToV7 } from './v7.js';
import { migrateToV8 } from './v8.js';
export const migrations = {
    2: migrateToV2,
    3: migrateToV3,
    4: migrateToV4,
    5: migrateToV5,
    6: migrateToV6,
    7: migrateToV7,
    8: migrateToV8
};
export const migrateState = MigrateFunctionBuilder.fromVersions(modelVersions).to(modelVersion).using(migrations).build();

//# sourceMappingURL=index.js.map